// removed by extract-text-webpack-plugin
module.exports = {"user-img":"user-img__21Znj","img-container":"img-container__2K4s2"};


//////////////////
// WEBPACK FOOTER
// ./styles/f2s/finalScreen.scss
// module id = 596
// module chunks = 68